
function getDateParts(dateInput) {
  const pad = (num, size = 2) => String(num).padStart(size, "0");

  const [datePart, timePart] = dateInput.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, secondMs] = timePart.split(":");
  const [second, ms = "0"] = secondMs.split(".");

  const date = new Date(Date.UTC(
    year,
    month - 1,
    day,
    Number(hour),
    Number(minute),
    Number(second),
    Number(ms.padEnd(3, '0'))
  ));

  return {
    year: date.getFullYear(),
    month: pad(date.getMonth() + 1),
    day: pad(date.getDate()),
    hours: pad(date.getHours()),
    minutes: pad(date.getMinutes()),
    seconds: pad(date.getSeconds()),
    milliseconds: pad(date.getMilliseconds(), 3)
  };
}

export function formatDate(dateInput) {
  const { day, month, year, hours, minutes, seconds } = getDateParts(dateInput);
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function formatShortDate(dateInput) {
  const { day, month, hours, minutes } = getDateParts(dateInput);
  return `${day}/${month} ${hours}:${minutes}`;
}

export function convertUTCToLocalISOString(dateInput) {
  const { year, month, day, hours, minutes, seconds, milliseconds } = getDateParts(dateInput);
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export function getTimeRange(period) {
  const periodToHours = {
    "24hours": 24,
    "7days": 7 * 24,
    "30days": 30 * 24,
  };
  const hours = periodToHours[period] ?? 24;
  return convertHoursToPastISOString(hours);
}

function convertHoursToPastISOString(hours) {
  const now = Date.now();
  const pastDate = new Date(now - hours * 60 * 60 * 1000);
  return pastDate.toISOString();
}